// const getDefaultState = () => {
//   return {

//   }
// }
// const state = getDefaultState()
const initState = {

}
const state = {
  ...initState,
  initState() {
    return initState
  }
}
const mutations = {

}

export default {
  namespaced: true,
  state,
  mutations
}
